// extracted by mini-css-extract-plugin
export default {"Drawer":"wWmmS62G","ContentRoot":"npOs5O_n"};